import userType from '../type/personType';

export default () => `
    users {
        ${userType()}
    }
`;
